import { Component, OnInit} from '@angular/core';
import { VesselService, VesselModel, PagerService, AlertService, PortService, Port, TableHeader, CommonService } from '../../services/index'
import { Util } from '../../utils/util'
import _ from 'lodash';
import similarity from 'string-similarity';

declare var $:any;

@Component({
  selector: 'port-list',
  templateUrl: 'port-list.html',
  styles: [`
  agm-map {
    height: 800px;
    width: 100%;
  }`]
})
export class PortList implements OnInit{

    
    clickedId:number;
    openId:number;

    allPortList: Array<Port> = new Array();
    portList: Array<Port> = new Array();
    pager: any = {};
    pagedItems: Array<Port> = new Array();
    
    condition:ConditionSearch = new ConditionSearch();

    isShowDetail:boolean = false;

    tabIndex:number = 0;

    headerList:Array<TableHeader> = null;


    //탭1
    defaultLatitude: number = 35.907756;
    defaultLongitude: number = 127.766922;
    defaultZoom:number = 6;
    searchPortCd:string = "";

    constructor(
        private pagerService: PagerService,
        private alertService:AlertService,
        private portService:PortService,
        private commonService:CommonService
    ) {
        this.makeHeader();
        commonService.headerSortedEmit.subscribe(data =>{
            if(data.type == 0){
                this.allPortList = data.data;
                this.searchPort();
            }
        });
        commonService.clearHeaderEmit.subscribe(data =>{
            if(data.type == 0){
                this.headerList = data.headerList;
            }
        });
    }

    ngOnInit(){
        this.getPortList(true);
    }

    makeHeader(){
        this.headerList = new Array<TableHeader>();
        this.headerList.push(new TableHeader(0, 'locationId', 'No.', true));
        this.headerList.push(new TableHeader(1, 'match', '일치율', true));
        this.headerList.push(new TableHeader(2, 'cntryCd', '국가 코드', true));
        this.headerList.push(new TableHeader(3, 'cntryNm', '국가명', true));
        this.headerList.push(new TableHeader(4, 'portCd', '항구 코드', true));
        this.headerList.push(new TableHeader(5, 'portNm', '항구명', true));
        this.headerList.push(new TableHeader(6, 'label', '라벨', true));
        this.headerList.push(new TableHeader(7, 'latitude', '위도', true));
        this.headerList.push(new TableHeader(8, 'longitude', '경도', true));
        this.headerList.push(new TableHeader(9, 'timeZone', '시간차', true));
        this.headerList.push(new TableHeader(10, 'fclScheduleCnt', 'Fcl Schedule Cnt', true));


    }

    getPortList(isInit:boolean){
        this.portService.getPortListAndFclScheduleCnt().subscribe(
            res =>{
                if(res.result){
                    this.allPortList = res.data;
                    this.portList = res.data;
                    if(!isInit){
                        this.searchPort();
                        let tempIndex = this.clickedId;
                        this.clickedId = null;
                        this.tableRowClick(tempIndex);
                    }else{
                        this.setPage(1);
                    }
                }
            }
        );
    }

    setPage(page:number){
        
        this.pager = this.pagerService.getPager(this.portList.length, page, 10);

        // if (page < 1) {
        //   return;
        // }
    
        if(page > this.pager.totalPages) {
          this.pager = this.pagerService.getPager(this.portList.length, this.pager.totalPages);
        }
    
        this.pagedItems = this.portList.slice(this.pager.startIndex, this.pager.endIndex + 1);

    }

    searchPort(event?) {
       
        if(event && event.keyCode != 13) return ;

        var filterValue = this.condition.text;

        if(this.allPortList.length < 1) return;

        this.portList = _.filter(this.allPortList, item => {
                if (!filterValue) return true;

                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                return valuesStr.indexOf(filter) >= 0;
        });
        
        if(event) this.setPage(1);
        else this.setPage(this.pager.currentPage);       
    }   

    tableRowClick(id:number){
        if(id == this.clickedId){
            return ;
        }
        this.clickedId = id;
    }

    openDetail(id:number){
        this.isShowDetail = true;
        this.openId = id;
    }

    add(){
        this.isShowDetail = true;
        this.openId = null;
    }

    closeDetail(){
        this.isShowDetail = false;
        this.openId = null;
    }

    refreshList(){
        this.getPortList(false);
        this.closeDetail();
    }

    findPort(event){
        if(!event) return

        let operPortNm = event.operPortNm;
        let portNmMapId = event.portNmMapId;

        if(operPortNm == null || operPortNm == undefined || operPortNm.length < 1) return 

        this.portList = _.filter(this.allPortList, (item:Port) => {
            if (!item.portNm) return false;
            if (similarity.compareTwoStrings(operPortNm, item.portNm) > 0.3) {
                item.match = similarity.compareTwoStrings(operPortNm, item.portNm).toFixed(2);
                return true;           
            }
        });

        this.portList = _.orderBy(this.portList, ['match'], ['desc']);
    
        this.setPage(1);

        this.clickedId = null;
    }

    selecedPort(event){
        if(event){
            this.defaultLatitude = event.latitude;
            this.defaultLongitude = event.longitude;
            this.defaultZoom = 12;
            this.searchPortCd = event.portCd;
        }else{
            this.defaultLatitude = 35.907756;
            this.defaultLongitude = 127.766922;
            this.defaultZoom = 6;
            this.searchPortCd = "";
        }
    }
}

class ConditionSearch{
    text:string = "";
}


// WEBPACK FOOTER //
// ./src/app/containers/port-map/port-list.ts